import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	checkboxContent: {
		color: THEME.colors.text.main,
		fontSize: 14,
		marginLeft: THEME.spacing.lg,
		width: 400,
	},
	container: {},
	header: {
		color: THEME.colors.text.main,
		fontSize: 14,
		marginTop: 16,
	},
});
